import colors from '@elegantstack/flow-ui-theme/src/theme/colors'

export default {
  ...colors,
  background: `#ffffff`,
  headerBg: `#fbfbfb`,
  footerBg: `#fbfbfb`
}
